import { useQuery } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CodeItemSearchCondition } from '../types/code';

/**
 * GET /api/eraf/codes/groups/{groupCode}/items — 코드 항목 목록
 * queryKey: ['common-code', 'items', groupCode, params]
 */
export function useCodeItems(groupCode: string | null, params?: CodeItemSearchCondition) {
  return useQuery({
    queryKey: ['common-code', 'items', groupCode, params],
    queryFn: () => codeApi.listItems(groupCode!, params),
    enabled: !!groupCode,
    staleTime: 30_000,
  });
}
